import React from "react";
import { PureComponent } from "react";
import {
  FormGroup,
  Table,
  Input,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  CustomInput
} from "reactstrap";
// import './SearchBar.css';
import OverlayLoading from "../Commons/OverlayLoading.jsx";
import { Link } from "react-router-dom";
import moment from "moment";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
class ArticleForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  formatTime(dateString) {
    return moment(dateString).format("YYYY-MM-DD");
  }

  render() {
    return (
      <div>
        <FormGroup>
          <label htmlFor="exampleFormControlSelect1">選擇分類</label>
          <Input
            id="exampleFormControlSelect1"
            type="select"
            onChange={e => this.props.handleCheckBoxChange(e)}
          >
            <option
              selected={
                this.props.data.category_ids
                  ? this.props.data.category_ids.indexOf(0) !== -1
                  : false
              }
              value={0}
              disabled={this.props.data.type !== 0}
            >
              請選擇
            </option>
            <option
              selected={
                this.props.data.category_ids
                  ? this.props.data.category_ids.indexOf(96) !== -1
                  : false
              }
              value={96}
            >
              工作求職
            </option>
            <option
              selected={
                this.props.data.category_ids
                  ? this.props.data.category_ids.indexOf(97) !== -1
                  : false
              }
              value={97}
            >
              餐館服務
            </option>
            <option
              selected={
                this.props.data.category_ids
                  ? this.props.data.category_ids.indexOf(98) !== -1
                  : false
              }
              value={98}
            >
              家政服務
            </option>
            <option
              selected={
                this.props.data.category_ids
                  ? this.props.data.category_ids.indexOf(99) !== -1
                  : false
              }
              value={99}
            >
              維修保養
            </option>
            <option
              selected={
                this.props.data.category_ids
                  ? this.props.data.category_ids.indexOf(100) !== -1
                  : false
              }
              value={100}
            >
              商家服務
            </option>
          </Input>
        </FormGroup>
        <FormGroup>
          <label htmlFor="exampleFormControlSelect1">選擇類型</label>
          <Input
            id="exampleFormControlSelect1"
            type="select"
            onChange={e => this.props.onTextInputChange(e, "type")}
          >
            <option
              selected={this.props.data.type === 0}
              value={0}
              disabled={this.props.data.type !== 0}
            >
              請選擇
            </option>
            <option selected={this.props.data.type === "right"} value={"right"}>
              側邊廣告
            </option>
            <option selected={this.props.data.type === "top"} value={"top"}>
              置頂廣告
            </option>
          </Input>
        </FormGroup>
        <FormGroup>
          <label htmlFor="exampleFormControlSelect1">期限</label>
          <Input
            id="exampleFormControlSelect1"
            type="select"
            onChange={e => this.props.onTextInputChange(e, "vacancy_weeks")}
          >
            <option
              selected={this.props.data.vacancy_weeks === 0}
              value={0}
              disabled={this.props.data.type !== 0}
            >
              請選擇
            </option>
            <option selected={this.props.data.vacancy_weeks === 1} value={1}>
              一週
            </option>
            <option selected={this.props.data.vacancy_weeks === 2} value={2}>
              兩週
            </option>
            <option selected={this.props.data.vacancy_weeks === 3} value={3}>
              三週
            </option>
            <option selected={this.props.data.vacancy_weeks === 4} value={4}>
              四週
            </option>
          </Input>
        </FormGroup>
      </div>
    );
  }
}

export default ArticleForm;
